module.exports = __webpack_public_path__ + "img/infinity.d7976d03.svg";